module.exports = __webpack_public_path__ + "static/media/check-circle.fbad39ef.svg";